'use client';

import StoreProvider from './StoreProvider';
import React, { useEffect } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from './ui/toaster';
import { useAppDispatch, useAppSelector } from '@/lib/RTK/hooks';
import { axiosClientInstance } from '@/lib/servies/axiosConfig';
import {
    logout,
    saveMobile,
    saveName,
    saveRegister,
    saveWallet,
    setAccessRoute,
    setPanel,
} from '@/lib/RTK/features/AuthSlice';
import { usePathname } from 'next/navigation';
import { getQueryClient } from '@/utils/query-client';

export default function Providers({ children }: { children: React.ReactNode }) {
    const queryClient = getQueryClient();
    return (
        <QueryClientProvider client={queryClient}>
            <StoreProvider>
                {children}
                <Toaster />
            </StoreProvider>
        </QueryClientProvider>
    );
}

export function CheckToken() {
    const pathname = usePathname();
    const token = useAppSelector((s) => s.auth_token_slice.token);

    const dispatch = useAppDispatch();
    useEffect(() => {
        const ac = new AbortController();

        if (token) {
            axiosClientInstance
                .post('/check_token', undefined, {
                    headers: { Auth: token },
                    signal: ac.signal,
                })
                .then((res) => {
                    if (res.data?.status === 0) {
                        dispatch(logout());
                    } else {
                        dispatch(saveWallet(res.data.result.user.wallet));
                        dispatch(saveName(res.data.result.user.name || null));
                        dispatch(saveRegister(res.data.result.user.register));
                        dispatch(saveMobile(res.data.result.user.mobile));
                        dispatch(setAccessRoute(res.data.result.user.matab));
                        dispatch(setPanel(res.data.result.user.panel));
                    }
                })
                .catch(() => {});
        } else dispatch(saveName(null));

        return () => {
            ac.abort();
        };
    }, [pathname, token, dispatch]);
    return null;
}

// export function GoftinoProvider({ disabled }: { disabled?: boolean }) {
//     const scriptLoadedRef = useRef(false);
//     const isMountedRef = useRef(false);

//     async function loadGoftino() {
//         if (
//             scriptLoadedRef.current ||
//             disabled ||
//             typeof window === 'undefined' ||
//             !isMountedRef.current
//         ) {
//             return;
//         }

//         try {
//             const i = '9vtI5t';
//             const d = document;
//             const l = localStorage.getItem('goftino_' + i);

//             const script = d.createElement('script');
//             script.async = true;
//             script.defer = true;
//             script.crossOrigin = 'anonymous';
//             script.src = `https://www.goftino.com/widget/${i}${
//                 l ? '?o=' + l : ''
//             }`;

//             script.onerror = () => {
//                 console.warn('Failed to load Goftino widget');
//                 scriptLoadedRef.current = true;
//             };
//             script.onload = () => {
//                 scriptLoadedRef.current = true;
//             };

//             const head = d.getElementsByTagName('head')[0];
//             const timer = setTimeout(() => {
//                 if (!scriptLoadedRef.current && isMountedRef.current) {
//                     head.appendChild(script);
//                 }
//             }, 300);

//             return () => clearTimeout(timer);
//         } catch (error) {
//             console.error('Goftino load error:', error);
//             scriptLoadedRef.current = true;
//         }
//     }

//     useEffect(() => {
//         isMountedRef.current = true;
//     }, []);

//     useEffect(() => {
//         if (disabled || typeof window === 'undefined') return;

//         const timer = setTimeout(() => {
//             loadGoftino();
//         }, 300);

//         return () => clearTimeout(timer);
//     }, [disabled]);

//     useEffect(() => {
//         return () => {
//             if (typeof window !== 'undefined') {
//                 const script = document.querySelector(
//                     'script[src*="goftino.com"]',
//                 );
//                 if (script) {
//                     script.remove();
//                 }
//                 scriptLoadedRef.current = false;
//                 isMountedRef.current = false;
//             }
//         };
//     }, []);

//     return null;
// }
